module.exports = __webpack_public_path__ + "img/es_lang.6d5803a7.png";